/**
 * Esta función suma dos números.
 * @param {string|number}
 * @returns {boolean}
 */

export const validateIdParams = (id) => {
  return /^\d{1,9}$/.test(id);
};
